module.exports = __webpack_public_path__ + "static/media/GB.ce8be7d0.svg";